import { useQueryClient } from '@tanstack/react-query';
import { trpc } from '../../lib/trpc';

/** Stan AI workspace'u (włączone, dostawca, symulacja, dostępność) — bez kosztów i sekretów. */
export function useCopilotStatus(enabled = true) {
  return trpc.copilot.status.useQuery({}, { enabled, staleTime: 60_000 });
}

/** Odświeżenie list po zapisie z Copilota (zadania, czas, Dziś, propozycje, historia AI). */
export function useCopilotInvalidate() {
  const utils = trpc.useUtils();
  const queryClient = useQueryClient();
  return {
    tasks: () => Promise.all([utils.tasks.invalidate(), queryClient.invalidateQueries({ queryKey: ['today'] })]),
    time: () =>
      Promise.all([
        utils.time.invalidate(),
        utils.projects.invalidate(),
        queryClient.invalidateQueries({ queryKey: ['today'] }),
      ]),
    jobs: () => Promise.all([utils.ai.listJobs.invalidate(), utils.ai.usage.invalidate()]),
  };
}
